import React from 'react';

import { ForumPost } from '../../utils/backend-api/forumPosts';
import ForumPostList from '../Forum/ForumPostList';
import NoResultsMessage from '../shared/NoResultsMessage';
import styles from './styles.module.scss';

interface SearchPostsListProps {
  content: ForumPost[];
}

const SearchPostsList = ({ content }: SearchPostsListProps) => {
  return (
    <>
      {content?.length > 0 ? (
        <div className={styles.forumPostList}>
          <ForumPostList forumPosts={content} />
        </div>
      ) : (
        <NoResultsMessage />
      )}
    </>
  );
};

export default SearchPostsList;
